import { WarningIcon } from '@approvalmax/ui/src/old/icons';
import { FC, memo } from 'react';

import AppStateScreen from '../AppStateScreen/AppStateScreen';
import { WarningStateScreenProps } from './WarningStateScreen.types';

const WarningStateScreen: FC<WarningStateScreenProps> = memo((props) => (
    <AppStateScreen {...props} icon={<WarningIcon />} />
));

export default WarningStateScreen;
